import script from "./EventsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventsPage.vue?vue&type=script&setup=true&lang=ts"

import "./EventsPage.vue?vue&type=style&index=0&id=a4df672c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4df672c"]])

export default __exports__